import Main from "./components/Main";
import "./scss/app.scss";

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
